import React, { useMemo, useState } from "react";
import styled from "styled-components";
import Review from "./review";

const Reviews = () => {
  const Reviews = [
    {
      name: "Shade",
      occupation: "Afrobeats Artist",
      nationality: "Nigerian",
      review:
        "Rated Afrika makes it so easy to get my music out there. I feel like my work is reaching new audiences every day!",
      avatar:
        "https://images.pexels.com/photos/1722198/pexels-photo-1722198.jpeg?auto=compress&cs=tinysrgb"
    },
    {
      name: "Ogbon",
      occupation: "Jollof Artist",
      nationality: "Ghanian",
      review:
        "Rated Afrika makes it so easy to get my music out there. I feel like my work is reaching new audiences every day!",
      avatar:
        "https://images.pexels.com/photos/3786525/pexels-photo-3786525.jpeg?auto=compress&cs=tinysrgb"
    },
    {
      name: "Ogaye",
      occupation: "French Artist",
      nationality: "French",
      review:
        "Rated Afrika makes it so easy to get my music out there. I feel like my work is reaching new audiences every day!",
      avatar:
        "https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb"
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const Next = () => {
    if (activeIndex < Reviews.length) {
      setActiveIndex(activeIndex + 1);
    }
  };
  const Prev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };
  return (
    <Container>
      <Review
        name={Reviews[activeIndex].name}
        occupation={Reviews[activeIndex].occupation}
        nationality={Reviews[activeIndex].nationality}
        avatar={Reviews[activeIndex].avatar}
        reviewText={Reviews[activeIndex].review}
        currentReviewIndex={activeIndex}
        reviewsLength={Reviews.length}
        next={() => Next()}
        prev={() => Prev()}
      />
    </Container>
  );
};

export default Reviews;

const Container = styled.div`
  width: 100%;
  padding: 12.6rem 10.4rem;
  @media only screen and (max-width: 769px) {
    padding: 3.5rem;
  }
`;
